import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=68b9125b&scoped=true"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=68b9125b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b9125b",
  null
  
)

export default component.exports